import { formatDate, getSelectioAxios } from '@/main';

export default class NotificationService {

  getNotifications(user, portfolioId) {
    return getSelectioAxios().get('/notifications/portfolios/' + (portfolioId != null && portfolioId > 0 ? portfolioId : 0))
      .then(result => result.data);
  }

  getArchivedNotifications(user, portfolioId) {
    return getSelectioAxios().get('/notifications/portfolios/' + portfolioId + '/archived')
      .then(result => result.data);
  }

  getNotificationsCount(user, idPortfolio) {
    return getSelectioAxios().get('/notifications/portfolios/' + (idPortfolio == null ? 0 : idPortfolio) + '/count')
      .then(result => result.data);
  }

  getCountTotalNotificationsByPortfolioAndPeriod(idPortfolio, dateFrom, atDate, listUsersByApplicationAndRole) {
    return getSelectioAxios().post('/notifications/portfolios/' + idPortfolio + '/periods/count', {
        'dateFrom': formatDate(dateFrom, 'yyyy-mm-dd'),
        'atDate': formatDate(atDate, 'yyyy-mm-dd'),
        'listUsersByApplicationAndRole': listUsersByApplicationAndRole,
      })
      .then(response => response.data);
  }

  getCountTotalNotificationsReadByPortfolioAndPeriod(idPortfolio, dateFrom, atDate, listUsersByApplicationAndRole) {
    return getSelectioAxios().post('/notifications/portfolios/' + idPortfolio + '/periods/read/count', {
        'dateFrom': formatDate(dateFrom, 'yyyy-mm-dd'),
        'atDate': formatDate(atDate, 'yyyy-mm-dd'),
        'listUsersByApplicationAndRole': listUsersByApplicationAndRole,
      })
      .then(response => response.data);
  }

  markNotifications(idNotifications) {
    const variables = {
      'idNotifications': idNotifications,
    };
    return getSelectioAxios().post('/notifications/mark', variables)
      .then(result => result.data);
  }
}
